import { faPencil, faEye, faTrash, faRupeeSign, faUserPlus, faCalendarDays } from '@fortawesome/free-solid-svg-icons';

export const AppIcons = {
  edit: faPencil,
  view: faEye,
  delete: faTrash,
  rupee: faRupeeSign,
  assignEmployee: faUserPlus,
  date: faCalendarDays
};
